module.exports = __webpack_public_path__ + "static/img/case2.939ecbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/case2.png
// module id = k6Nr
// module chunks = 2